import { useState, useEffect } from "react";
import { Bounce, toast } from "react-toastify";
import api from "../api";

const TrainerTitoliStudio = ({
  titoliStudio: initialTitoli = [],
  codiceFiscale = "",
  operatorView,
}) => {
  const [titoliStudio, setTitoliStudio] = useState(initialTitoli || []);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState({});

  useEffect(() => {
    setTitoliStudio(initialTitoli || []);
  }, [initialTitoli]);

  const handleEdit = (id) => {
    const titolo = titoliStudio.find((t) => t.idTitoloTrainer === id);
    if (!titolo) return;

    setForm({
      [id]: {
        nomeTitolo: titolo.nomeTitolo || "",
        rilasciatoIl: titolo.rilasciatoIl || "",
        da: titolo.da || "",
      },
    });

    setEditingId(id);
  };

  const handleCancel = (id) => {
    const original = initialTitoli.find((t) => t.idTitoloTrainer === id);
    if (original) {
      setTitoliStudio((prev) =>
        prev.map((t) => (t.idTitoloTrainer === id ? { ...original } : t))
      );
    }
    setEditingId(null);
    setErrors((prev) => {
      const copy = { ...prev };
      Object.keys(copy).forEach((k) => {
        if (k.startsWith(`${id}-`)) delete copy[k];
      });
      return copy;
    });
  };

  const handleChange = (id, field, value) => {
    setForm((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
    setErrors((prev) => ({ ...prev, [`${id}-${field}`]: undefined }));
  };

  const validate = (id) => {
    const inputErrors = {};
    const f = form[id];
    if (!f.nomeTitolo.trim())
      inputErrors[`${id}-nomeTitolo`] = "Nome titolo obbligatorio";
    if (!f.rilasciatoIl)
      inputErrors[`${id}-rilasciatoIl`] = "Data rilascio obbligatoria";
    if (!f.da.trim()) inputErrors[`${id}-da`] = "Da obbligatorio";
    setErrors((prev) => ({ ...prev, ...inputErrors }));
    return Object.keys(inputErrors).length === 0;
  };

  const handleSave = async (id) => {
    if (!validate(id)) return;
    const f = form[id];
    const payload = {
      nomeTitolo: f.nomeTitolo,
      rilasciatoIl: f.rilasciatoIl,
      da: f.da,
      trainerCodiceFiscale: codiceFiscale,
    };

    try {
      setLoading((prev) => ({ ...prev, [id]: true }));
      const res = await api.put(`/titoli-studio/${id}`, payload);
      if (res.status >= 200 && res.status < 300) {
        setTitoliStudio((prev) =>
          prev.map((t) => (t.idTitoloTrainer === id ? { ...t, ...f } : t))
        );
        setEditingId(null);
        toast.success("Titolo aggiornato!", {
          position: "top-right",
          autoClose: 3000,
          transition: Bounce,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Errore durante il salvataggio!", {
        position: "top-right",
        autoClose: 5000,
        transition: Bounce,
      });
    } finally {
      setLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  return (
    <div className="trainer-esperienze-lavorative">
      <div className="trainer-esperienze-lavorative-title">Titoli Studio</div>
      <div className="trainer-data-fields">
        {titoliStudio.length === 0 ? (
          <div className="no-data">Nessun titolo presente.</div>
        ) : (
          titoliStudio.map((titolo) => {
            const id = titolo.idTitoloTrainer;
            const isEditing = editingId === id;
            const isSaving = !!loading[id];

            return (
              <div className="trainer-data" key={id}>
                {/* Tipologia Titolo - always disabled */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Tipologia Titolo:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        value={titolo.tipologiaTitolo?.titoloTipologia || ""}
                        disabled
                      />
                    ) : (
                      <span className="span-value">
                        {titolo.tipologiaTitolo?.titoloTipologia || ""}
                      </span>
                    )}
                  </div>
                </div>

                {/* Nome Titolo */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Titolo Studi:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        value={form[id]?.nomeTitolo || ""}
                        onChange={(e) =>
                          handleChange(id, "nomeTitolo", e.target.value)
                        }
                      />
                    ) : (
                      <span className="span-value">{titolo.nomeTitolo}</span>
                    )}
                    {errors[`${id}-nomeTitolo`] && (
                      <span className="error-msg">
                        {errors[`${id}-nomeTitolo`]}
                      </span>
                    )}
                  </div>
                </div>

                {/* Rilasciato Il */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Rilasciato Il:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        type="date"
                        value={form[id]?.rilasciatoIl || ""}
                        onChange={(e) =>
                          handleChange(id, "rilasciatoIl", e.target.value)
                        }
                      />
                    ) : (
                      <span className="span-value">{titolo.rilasciatoIl}</span>
                    )}
                    {errors[`${id}-rilasciatoIl`] && (
                      <span className="error-msg">
                        {errors[`${id}-rilasciatoIl`]}
                      </span>
                    )}
                  </div>
                </div>

                {/* Da - editable input when editing */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Da:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        value={form[id]?.da || ""}
                        onChange={(e) => handleChange(id, "da", e.target.value)}
                      />
                    ) : (
                      <span className="span-value">{titolo.da}</span>
                    )}
                    {errors[`${id}-da`] && (
                      <span className="error-msg">{errors[`${id}-da`]}</span>
                    )}
                  </div>
                </div>

                {/* Action buttons */}
                {!operatorView && (
                  <div className="trainer-edit-actions">
                    {isEditing ? (
                      <>
                        <button
                          type="button"
                          className="save-btn"
                          onClick={() => handleSave(id)}
                          disabled={isSaving}
                        >
                          Salva
                        </button>
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={() => handleCancel(id)}
                          disabled={isSaving}
                        >
                          Annulla
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        className="edit-btn"
                        onClick={() => handleEdit(id)}
                        disabled={editingId !== null}
                      >
                        Modifica
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default TrainerTitoliStudio;
